module.exports = __webpack_public_path__ + "static/media/Anova-BoldItalic.35598824.woff2";